import { MessageCircle, Users, HeartHandshake, Plane, Sparkles } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { SectionTitle } from "@/components/SectionTitle";
import { Reveal } from "@/components/Reveal";
import { ASSETS, waLink, WA_MESSAGES } from "@/lib/site";

const PROFILE = [
  { icon: HeartHandshake, title: "Gosta de pessoas", text: "Você se realiza ao ajudar e criar boas experiências para os clientes." },
  { icon: Plane, title: "Ama viagens", text: "Turismo é uma paixão e você adora descobrir novos destinos." },
  { icon: Users, title: "Trabalha em equipe", text: "Valoriza colaboração, organização e bom relacionamento." },
  { icon: Sparkles, title: "Busca crescer", text: "Quer evoluir junto com uma agência moderna e em movimento." },
];

export default function TrabalheConosco() {
  return (
    <>
      <PageHero
        overline="Faça parte"
        title="Trabalhe conosco"
        subtitle="Gosta de turismo, atendimento e relacionamento? Venha fazer parte do time da Miríade Turismo."
        seoTitle="Trabalhe Conosco | Miríade Turismo"
        seoDescription="Faça parte da equipe da Miríade Turismo. Envie seu currículo e venha trabalhar com quem ama turismo e atendimento."
      />

      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <p className="text-lg leading-relaxed text-ink-soft">
              Na Miríade Turismo, acreditamos que as melhores viagens começam com pessoas que cuidam de
              cada detalhe. Estamos sempre em busca de talentos que se conectam com o nosso propósito:
              ajudar os clientes a viajar com mais segurança, praticidade e atendimento humano.
            </p>
            <p className="mt-5 text-lg leading-relaxed text-ink-soft">
              Se você gosta de turismo, atendimento e relacionamento, queremos conhecer você. Envie o
              seu currículo e conte um pouco sobre a sua trajetória.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="px-4 pb-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <SectionTitle center overline="O perfil que combina" title="Quem buscamos" />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {PROFILE.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div className="h-full rounded-3xl border border-border bg-white p-8 shadow-soft">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light">
                    <p.icon size={26} className="text-brand" />
                  </div>
                  <h3 className="mt-6 font-heading text-lg font-semibold text-ink">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-soft">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 pb-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          <div className="relative flex flex-col items-center gap-8 overflow-hidden rounded-3xl border border-brand-light bg-brand-light/70 px-6 py-10 text-center sm:flex-row sm:px-12 sm:text-left">
            <img src={ASSETS.mascot} alt="Mascote da Miríade Turismo" className="h-40 w-40 shrink-0 object-contain drop-shadow-xl animate-float" />
            <div>
              <h2 className="font-heading text-2xl font-bold tracking-tight text-ink sm:text-3xl">Envie o seu currículo</h2>
              <p className="mt-3 max-w-md text-base leading-relaxed text-ink-soft">
                Mande uma mensagem para a nossa equipe pelo WhatsApp com o seu currículo e um breve
                resumo sobre você. Teremos prazer em conhecer a sua história.
              </p>
              <a
                href={waLink(WA_MESSAGES.work)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="work-whatsapp-btn"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white transition-all hover:scale-[1.03] hover:bg-[#1ebe5d]"
              >
                <MessageCircle size={18} /> Enviar currículo pelo WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
